/* Scent Nation v1.3.0 - live label-on-jar previews: homepage hero (Birthday Story), the personalise studio (every
   template) and personalised product pages (every product with a template in snippets/sn-persn.liquid). Needs sn-label.js (SNLabel + templates); the Birthday Story also needs
   sn-birthdate-data.js. Everything is drawn from the same code that prints the labels. */
(function () {
  'use strict';
  if (window.SNPersonalise) return; // several sections include this file: run once
  window.SNPersonalise = {};
  var L = window.SNLabel;
  if (!L) return;
  var D = window.SN_BIRTHDATE;
  var measure = document.createElement('div');
  measure.setAttribute('aria-hidden', 'true');
  measure.style.cssText = 'position:absolute;left:-10000px;top:0;visibility:hidden;pointer-events:none';
  document.body.appendChild(measure);

  function pad(n) { return ('0' + n).slice(-2); }
  function signOf(key) {
    if (!D || !D.days[key]) return null;
    for (var i = 0; i < D.signs.length; i++) if (D.signs[i].key === D.days[key].sign) return D.signs[i];
    return null;
  }
  function jarReady(jarEl, url, cb) {
    if (jarEl.getAttribute('data-bg') === url) { cb(); return; }
    var im = new Image();
    im.onload = im.onerror = function () { jarEl.style.backgroundImage = "url('" + url + "')"; jarEl.setAttribute('data-bg', url); cb(); };
    im.src = url;
  }
  /* ---- Birthdate Story label (2026-10-05): the 102 x 64 mm front + back from the label project's birthdate-story/ module, the same
     engine the Label Studio prints with. Loaded only when a Birthday Story preview is drawn (window.SN_BDS from snippets/sn-bds-assets). */
  var bdsQ = null;
  function bdsOn() { return !!window.SN_BDS; }
  function bdsReady() { return !!(window.BDS && window.BDSLabel && window.BDS_DATA); }
  function loadBDS(cb) {
    if (bdsReady()) { cb(); return; }
    var A = window.SN_BDS; if (!A) { cb(); return; }
    if (bdsQ) { bdsQ.push(cb); return; }
    bdsQ = [cb];
    window.BDS_URL = function (p) {   // the module's art paths -> this theme's flat asset files
      var m = /figures\/(western|animal)\/([^\/]+)\.png$/.exec(p);
      return m ? ((A.map || {})[(m[1] === 'western' ? 'w/' : 'a/') + m[2]] || p) : p;
    };
    var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = A.css; document.head.appendChild(l);
    var urls = [A.data, A.js];
    (function next(i) {
      if (i >= urls.length) { var q = bdsQ; bdsQ = null; q.forEach(function (f) { f(); }); return; }
      var sc = document.createElement('script'); sc.src = urls[i]; sc.onload = sc.onerror = function () { next(i + 1); }; document.head.appendChild(sc);
    })(0);
  }
  function bdsOrder(vals, cfg) {
    var k = vals.key || '07-14', y = +vals.year || +((cfg.sample || {}).year) || 2000;
    return { order_id: 'PREVIEW', name: String(vals.name || '').trim() || (cfg.sample || {}).name || 'Elizabeth', date_of_birth: y + '-' + k,
      western_sign: vals.west || '', chinese_animal: vals.cnA || '', chinese_element: vals.cnE || '', confirmed: true,
      name_font: vals.nameFont === 'classic' ? 'classic' : 'script' };
  }
  function bdsModel(vals, cfg) {
    var md = window.BDS.compose(bdsOrder(vals, cfg), { mode: 'customer' });
    if (!md.ok) md = window.BDS.compose(bdsOrder({ key: vals.key, name: vals.name }, cfg), { mode: 'customer' });   // e.g. 29 Feb in a non-leap year
    if (!md.ok) md = window.BDS.compose(bdsOrder({ name: vals.name }, cfg), { mode: 'customer' });
    return md;
  }
  /* Name style picker (Deng 2026-10-05: "give them a choice for font"): Script (default) or Classic, each showing the name */
  function fontPickHtml(uid, name, chosen) {
    var nm = String(name || 'Elizabeth').replace(/[<>&"]/g, '').slice(0, 20) || 'Elizabeth';
    return '<div class="field bds-font" role="radiogroup" aria-label="Name style"><span class="label">Name style</span><div class="bds-font-opts">' +
      [['script', 'Script'], ['classic', 'Classic']].map(function (o) {
        return '<label class="bds-font-opt"><input type="radio" name="' + uid + '" value="' + o[0] + '"' + (o[0] === chosen ? ' checked' : '') + ' data-bds-font>' +
          '<span class="bds-font-k">' + o[1] + '</span><span class="bds-font-s nf-' + o[0] + '" data-bds-font-sample>' + nm + '</span></label>';
      }).join('') + '</div></div>';
  }
  function fontSamples(scope, name) {
    var nm = String(name || '').trim().slice(0, 20) || 'Elizabeth';
    Array.prototype.forEach.call(scope.querySelectorAll('[data-bds-font-sample]'), function (e) { if (e.textContent !== nm) e.textContent = nm; });
  }
  function isBds(cfg) { return cfg.tpl === 'story' && cfg.bds !== false && bdsOn(); }
  /* cfg: {tpl, occasion, emblem, kicker, quote}; vals: slot values; opts: {scent, netWeight, logoSrc} */
  function build(cfg, vals, opts) {
    var el;
    if (isBds(cfg) && bdsReady()) {   // Birthdate Story (2026-10-05): opts.side 'back' draws the back label
      var md = bdsModel(vals, cfg);
      return opts.side === 'back' ? window.BDSLabel.back(md, {}) : window.BDSLabel.front(md, {});
    }
    if (cfg.tpl === 'story' && cfg.dual && window.SNDual) {  // Western + Chinese zodiac front label (label-dual.js, 2026-10-04)
      var k = vals.key || '07-14', yy = +vals.year || +((cfg.sample || {}).year) || 2000;
      el = window.SNDual.front({ y: yy, m: +k.slice(0, 2), d: +k.slice(3), name: vals.name || '', scent: opts.scent || '', netWeight: opts.netWeight,
        logoSrc: String(opts.classicLogoSrc || '').replace('sn-logo-label-classic.png', 'sn-logo-wordmark.png') || undefined });
      if (opts.side === 'back') el = window.SNDual.back({ y: yy, m: +k.slice(0, 2), d: +k.slice(3), logoSrc: String(opts.classicLogoSrc || '').replace('sn-logo-label-classic.png', 'sn-logo-wordmark.png') || undefined });
    } else if (cfg.tpl === 'story') {
      el = L.render(vals.key || '07-14', { name: vals.name || '', scent: opts.scent || '', netWeight: opts.netWeight, logoSrc: opts.logoSrc });
    } else {
      var d = {};
      for (var k in vals) if (vals[k] != null && (vals[k] !== '' || cfg.recipe)) d[k] = vals[k];  // a recipe keeps '' = left empty
      if (cfg.recipe) d.recipe = cfg.recipe;  // Scent Nation's own label design (label-sn.js)
      if (!d.kicker && cfg.kicker) d.kicker = cfg.kicker;
      if (cfg.quote) d.quote = cfg.quote;
      d.samples = cfg.sample || {};
      el = L.renderTemplate(cfg.tpl, d, { occasion: cfg.occasion, emblem: cfg.emblem, scent: opts.scent, netWeight: opts.netWeight, logoSrc: opts.logoSrc, classicLogoSrc: opts.classicLogoSrc });
    }
    return el;
  }
  function imagesReady(el) {  // photos and maps set the layout: wait for them before fitting the text
    return Promise.all(Array.prototype.map.call(el.querySelectorAll('img'), function (im) {
      return im.complete ? null : new Promise(function (r) { im.onload = im.onerror = r; });
    }));
  }
  var ticket = 0;
  function fitAny(el, cfg) {
    if (el.classList.contains('bds-label')) window.BDSLabel.fit(el);
    else if (el.classList.contains('dz')) {} else if (cfg.tpl === 'story') L.fit(el); else L.fitTemplate(el);
  }
  function artReady(el) { return el.classList.contains('bds-label') ? window.BDSLabel.ready(el) : null; }
  function draw(jarEl, cfg, vals, opts, done) {
    if (isBds(cfg) && !bdsReady()) { loadBDS(function () { draw(jarEl, cfg, vals, opts, done); }); return; }
    var my = ++ticket;
    var el = build(cfg, vals, opts);
    measure.appendChild(el);
    void el.offsetWidth;  // start loading any font this label needs, then wait for it (Scent Nation's labels use several)
    L.fontsReady().then(function () { return document.fonts.ready; }).then(function () { return imagesReady(el); }).then(function () { return artReady(el); }).then(function () {
      fitAny(el, cfg);
      L.wrapOnJar(jarEl, el, isBds(cfg) ? { jar: 'cream' } : undefined);   // Birthdate Story is the cream jar (Deng 2026-10-05)
      if (el.parentNode) el.parentNode.removeChild(el);
      if (done) done();
    });
    return my;
  }

  /* ---------------- homepage hero: Birthday Story ---------------- */
  Array.prototype.forEach.call(document.querySelectorAll('[data-snhero]'), function (root) {
    var jar = root.querySelector('[data-snhero-jar]'), form = root.querySelector('[data-snhero-form]');
    var cap = root.querySelector('[data-snhero-cap]'), go = root.querySelector('[data-snhero-go]');
    var holder = root.querySelector('.hstory-jar'), base = root.getAttribute('data-url') || '#';
    var dim = { 1: 31, 2: 29, 3: 31, 4: 30, 5: 31, 6: 30, 7: 31, 8: 31, 9: 30, 10: 31, 11: 30, 12: 31 };
    var heroLive = !bdsOn();   // Birthdate Story: the first paint is the static jar image (same label); the module loads on first use
    function update() {
      var m = +form.month.value, d = Math.min(+form.day.value, dim[m]);
      Array.prototype.forEach.call(form.day.options, function (o) { o.disabled = +o.value > dim[m]; });
      if (+form.day.value !== d) form.day.value = String(d);
      var key = pad(m) + '-' + pad(d), name = (form.name.value || '').trim(), s = signOf(key), day = D && D.days[key];
      var yr = form.year ? form.year.value : '';
      if (bdsOn()) {
        if (bdsReady()) {
          var md = bdsModel({ key: key, year: yr, name: name }, { sample: { year: '2000' } });
          if (md.ok) cap.innerHTML = d + ' ' + D.months[m - 1].name + ' ' + (md.ids.iso || '').slice(0, 4) + ' · ' + md.ids.sign + ' + ' + md.ids.element + ' ' + md.ids.animal +
            ' · <b>“' + String(window.BDS_DATA.birthdays[key].title).replace(/[<>&]/g, '') + '”</b>';
        }
      } else if (day && s) cap.innerHTML = d + ' ' + D.months[m - 1].name + ' · ' + s.name + ' · <b>“' + day.title.replace(/[<>&]/g, '') + '”</b>';
      // the date and name travel only to the Birthday Story product page (until it launches the button goes to a collection)
      go.href = /\/products\//.test(base) ? base + '?date=' + key + (yr ? '&year=' + yr : '') + (name ? '&name=' + encodeURIComponent(name) : '') : base;
      if (!heroLive) return;
      jarReady(jar, root.getAttribute('data-jar'), function () {
        draw(jar, { tpl: 'story', sample: { year: '2000' } }, { key: key, name: name, year: yr }, { logoSrc: root.getAttribute('data-logo') }, function () { holder.classList.add('live'); });
      });
    }
    function wake() { if (!heroLive) { heroLive = true; loadBDS(update); } }
    form.addEventListener('focusin', wake);
    form.addEventListener('pointerdown', wake);
    var t = 0;
    form.addEventListener('change', update);
    form.addEventListener('input', function (e) { if (e.target.name === 'name') { clearTimeout(t); t = setTimeout(update, 140); } });
    form.addEventListener('submit', function (e) { e.preventDefault(); window.location.href = go.href; });
    if (window.ResizeObserver) { var w0 = 0; new ResizeObserver(function () { var w = jar.clientWidth; if (Math.abs(w - w0) > 2) { w0 = w; if (holder.classList.contains('live')) update(); } }).observe(jar); }
    update();
  });

  /* star map data loads only when a star map is shown (it is large): scripts in order, then the callback */
  var skyWaiting = null;
  function loadSky(list, cb) {
    if (window.SNSky) { cb(); return; }
    if (skyWaiting) { skyWaiting.push(cb); return; }
    skyWaiting = [cb];
    var urls = String(list || '').split('|').filter(Boolean);
    (function next(i) {
      if (i >= urls.length) { var w = skyWaiting; skyWaiting = null; w.forEach(function (f) { f(); }); return; }
      var sc = document.createElement('script'); sc.src = urls[i]; sc.onload = sc.onerror = function () { next(i + 1); }; document.head.appendChild(sc);
    })(0);
  }

  /* ---------------- personalise studio + product pages: any template ---------------- */
  function fieldHtml(f, i, uid) {
    var id = uid + '-' + i, lab = f.label.replace(/[<>&]/g, ''), ml = f.maxlength ? ' maxlength="' + f.maxlength + '"' : '';
    var ph = f.placeholder ? ' placeholder="' + String(f.placeholder).replace(/"/g, '&quot;') + '"' : '';
    if (f.type === 'file') return '<div class="field"><label for="' + id + '">' + lab + '</label><input type="file" accept="image/*" id="' + id + '" data-slot="' + f.slot + '"></div>';
    if (f.type === 'xmas') {  // Christmas candle: the 4 printed designs (same values as the product's own order field)
      return '<div class="field"><label for="' + id + '">' + lab + '</label><select id="' + id + '" data-slot="' + f.slot + '">' +
        ['Classic Holly', "Season's Greetings", 'Candy Cane', 'Gingerbread'].map(function (v) { return '<option value="' + v.replace(/"/g, '&quot;') + '">' + v + '</option>'; }).join('') + '</select></div>';
    }
    if (f.type === 'flower') {  // birth month: the same 12 values as the birth flower product's own order field
      var BF = ['January — Carnation', 'February — Violet', 'March — Daffodil', 'April — Daisy', 'May — Lily of the Valley', 'June — Rose', 'July — Larkspur',
        'August — Gladiolus', 'September — Aster', 'October — Marigold', 'November — Chrysanthemum', 'December — Holly'];
      return '<div class="field"><label for="' + id + '">' + lab + '</label><select id="' + id + '" data-slot="' + f.slot + '"><option value="">Choose their birth month…</option>' +
        BF.map(function (v) { return '<option value="' + v + '">' + v + '</option>'; }).join('') + '</select></div>';
    }
    if (f.type === 'textarea') return '<div class="field"><label for="' + id + '">' + lab + '</label><textarea id="' + id + '" data-slot="' + f.slot + '"' + ml + ph + '></textarea></div>';
    return '<div class="field"><label for="' + id + '">' + lab + '</label><input type="text" id="' + id + '" data-slot="' + f.slot + '"' + ml + ph + '></div>';
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-snstudio]'), function (root, n) {
    var cfgs = JSON.parse(root.querySelector('[data-snstudio-config]').textContent);
    var tabs = root.querySelector('[data-snstudio-tabs]'), fields = root.querySelector('[data-snstudio-fields]');
    var jar = root.querySelector('[data-snstudio-jar]'), go = root.querySelector('[data-snstudio-go]'), note = root.querySelector('[data-snstudio-note]');
    var logo = root.getAttribute('data-logo'), jarUrl = root.getAttribute('data-jar'), photoUrl = null, active = 0;
    // photo_first tabs (2026-10-05 Deng: "can you use this instead"): the product's own main photo shows until they type or add a photo
    var poster = root.querySelector('[data-snstudio-poster]'), posterOn = false;
    tabs.innerHTML = cfgs.map(function (c, i) {
      // 2026-10-06 Deng ("it looks messy"): equal tiles in a grid; Birthday Story is the full-width feature tile with its own line
      return '<button type="button" class="pstudio-tab" role="tab" aria-selected="' + (i === 0) + '" data-i="' + i + '" data-tpl="' + c.tpl + '">' + c.tab.replace(/[<>&]/g, '') +
        (c.tpl === 'story' ? '<span class="pstudio-new">New</span><small>366 original labels \u00b7 one for every birthday</small>' : '') + '</button>';
    }).join('');
    // Street map tab: as they type the address, find it (SNMap.geocode, OpenStreetMap place search) and draw that street map onto
    // the label. The map code loads only when someone types here, so the homepage stays light. Framing is fine-tuned on the product page.
    var live = { img: null, ticket: 0, t: 0 };
    function isMap(c) { return !!(c && c.recipe && (c.recipe.lines || []).some(function (l) { return l.s === 'map'; })); }
    function mapLibs(cb) {
      var need = [];
      if (!window.maplibregl) need.push('https://cdn.jsdelivr.net/npm/maplibre-gl@4.7.1/dist/maplibre-gl.js');
      if (!window.SNMap && root.getAttribute('data-map')) need.push(root.getAttribute('data-map'));
      (function next(i) {
        if (i >= need.length) { cb(window.SNMap && window.SNMap.geocode && window.maplibregl ? null : new Error('map')); return; }
        var sc = document.createElement('script'); sc.src = need[i]; sc.onload = function () { next(i + 1); }; sc.onerror = function () { cb(new Error('map')); };
        document.head.appendChild(sc);
      })(0);
    }
    function findMap(q) {
      var my = ++live.ticket, c = cfgs[active], off = 'Live map search isn\u2019t available here: you\u2019ll frame your spot on the next page.';
      var setImg = function (u) { var old = live.img; live.img = u; if (old) setTimeout(function () { URL.revokeObjectURL(old); }, 4000); render(); };
      if (!q) { note.textContent = c.note || ''; if (live.img) setImg(null); return; }
      note.textContent = 'Finding \u201c' + q + '\u201d on the map\u2026';
      mapLibs(function (err) {
        if (my !== live.ticket) return;
        if (err) { note.textContent = off; return; }
        window.SNMap.geocode(q).then(function (res) {
          if (my !== live.ticket) return;
          if (!res.length) { note.textContent = 'We couldn\u2019t find \u201c' + q + '\u201d. Try the street and suburb, or frame your spot on the next page.'; return; }
          return window.SNMap.snapshot({ lat: res[0].lat, lon: res[0].lon, zoom: res[0].zoom, shape: 'rect', tone: c.recipe && c.recipe.tone, px: 700 }).then(function (u) {
            if (my !== live.ticket) { URL.revokeObjectURL(u); return; }
            setImg(u); note.textContent = 'Showing ' + res[0].label + '. You can fine-tune the spot on the next page.';
          });
        }).catch(function () { if (my === live.ticket) note.textContent = off; });
      });
    }
    function values() {
      var c = cfgs[active], v = {};
      Array.prototype.forEach.call(fields.querySelectorAll('[data-slot]'), function (inp) { if (inp.type !== 'file') v[inp.getAttribute('data-slot')] = inp.value.trim(); });
      if (c.tpl === 'photo' || c.tpl === 'photoclassic' || (c.recipe && c.recipe.photo)) v.photo = photoUrl || (c.recipe && c.recipe.pet && c.samplePet ? c.samplePet : c.samplePhoto);
      if (isMap(c)) v.mapImg = live.img || root.getAttribute('data-map-sample');  // the place they typed, else a pre-drawn map (Nelson Bay)
      if (c.tpl === 'story') {
        v.key = (fields.querySelector('[data-slot=key]') || {}).value || '07-14';
        v.nameFont = studioFont;
        var yy = fields.querySelector('[data-slot=year]'); if (yy && yy.value) v.year = yy.value;
      }
      Object.keys(c.sample || {}).forEach(function (k) { if (!v[k]) v[k] = c.sample[k]; });
      return v;
    }
    function render() {
      var c = cfgs[active];
      var needsSky = c.tpl === 'starmap' || (c.recipe && (c.recipe.lines || []).some(function (l) { return l.s === 'chart'; }));
      if (needsSky && !window.SNSky) { loadSky(root.getAttribute('data-sky'), render); return; }
      if (poster) {
        poster.hidden = !posterOn;
        jar.style.visibility = posterOn ? 'hidden' : '';
        if (posterOn) { poster.src = c.poster; poster.alt = c.posterAlt || c.tab; }
      }
      if (c.tpl === 'story' && bdsOn()) fontSamples(fields, (fields.querySelector('[data-slot=name]') || {}).value);
      if (!posterOn) jarReady(jar, c.tpl === 'story' && bdsOn() && root.getAttribute('data-jar-cream') ? root.getAttribute('data-jar-cream') : jarUrl, function () { draw(jar, c, values(), { logoSrc: logo, classicLogoSrc: root.getAttribute('data-logo-classic'), scent: c.scent, side: c.tpl === 'story' ? studioSide : 'front' }); });
      var q = [];
      if (c.tpl === 'story' && bdsOn()) {   // the product page reads ?date=MM-DD&year=&name=
        var vv = values(); q.push('date=' + vv.key); if (vv.year) q.push('year=' + vv.year); if (studioFont === 'classic') q.push('font=classic');
      }
      Array.prototype.forEach.call(fields.querySelectorAll('[data-slot]'), function (inp) { if (inp.type !== 'file' && inp.value.trim()) q.push('pf_' + inp.getAttribute('data-slot') + '=' + encodeURIComponent(inp.value.trim())); });
      if (c.live === false) {   // product not on sale yet (e.g. Birthday Story while it is a draft): never link to a 404 (audit 2026-10-05)
        go.removeAttribute('href'); go.setAttribute('aria-disabled', 'true'); go.textContent = 'Coming soon';
      } else {
        go.removeAttribute('aria-disabled');
        go.href = c.url + (q.length ? '?' + q.join('&') : '');
        go.textContent = c.go;
      }
    }
    function select(i) {
      active = i;
      Array.prototype.forEach.call(tabs.children, function (b, j) { b.setAttribute('aria-selected', String(j === i)); });
      var c = cfgs[i];
      var html = c.fields.map(function (f, k) { return fieldHtml(f, k, 'st' + n + i); }).join('');
      if (c.tpl === 'story') {
        var opts = '';
        Object.keys(D ? D.days : {}).forEach(function (key) {
          var dd = D.days[key]; opts += '<option value="' + key + '"' + (key === '07-14' ? ' selected' : '') + '>' + dd.d + ' ' + D.months[dd.m - 1].name + '</option>';
        });
        html = '<div class="field"><label for="st' + n + 'date">Their birthday</label><select id="st' + n + 'date" data-slot="key">' + opts + '</select></div>' + html;
        if (bdsOn()) {   // Birthdate Story: the birth year sets their Chinese zodiac; front/back toggle
          var yo = '<option value="">Year</option>', y0 = new Date().getFullYear();
          for (var yi = y0; yi >= y0 - 104; yi--) yo += '<option value="' + yi + '"' + (yi === 2000 ? ' selected' : '') + '>' + yi + '</option>';
          html = html.replace('</select></div>', '</select></div><div class="field"><label for="st' + n + 'year">Birth year</label><select id="st' + n + 'year" data-slot="year">' + yo + '</select></div>') +
            fontPickHtml('st' + n + 'font', '', studioFont) +
            '<div class="field pstudio-side" role="group" aria-label="Label side"><button type="button" class="pstudio-tab" data-bds-side="front" aria-pressed="true">Front</button><button type="button" class="pstudio-tab" data-bds-side="back" aria-pressed="false">Back</button></div>';
        }
      }
      fields.innerHTML = html;
      photoUrl = null;
      live.ticket++; if (live.img) { URL.revokeObjectURL(live.img); live.img = null; }
      note.textContent = c.note || '';
      posterOn = !!c.poster;
      render();
    }
    var studioSide = 'front', studioFont = 'script';
    tabs.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) { studioSide = 'front'; select(+b.getAttribute('data-i')); } });
    fields.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bds-side]'); if (!b) return;
      studioSide = b.getAttribute('data-bds-side');
      Array.prototype.forEach.call(fields.querySelectorAll('[data-bds-side]'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      render();
    });
    var t = 0;
    fields.addEventListener('input', function (e) {
      posterOn = false;
      clearTimeout(t); t = setTimeout(render, 140);
      if (isMap(cfgs[active]) && e.target.getAttribute('data-slot') === 'location') { clearTimeout(live.t); live.t = setTimeout(function () { findMap(e.target.value.trim()); }, 800); }
    });
    fields.addEventListener('change', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-bds-font')) studioFont = e.target.value === 'classic' ? 'classic' : 'script';
      if (e.target.type === 'file' && e.target.files && e.target.files[0]) { photoUrl = URL.createObjectURL(e.target.files[0]); }
      posterOn = false;
      render();
    });
    select(0);
  });

  /* ---------------- static-content jars: any template with sample values, drawn when near the viewport ---------------- */
  function drawSample(jar) {
    var cfg = JSON.parse(jar.getAttribute('data-snjar')), vals = {};
    Object.keys(cfg.sample || {}).forEach(function (k) { vals[k] = cfg.sample[k]; });
    if ((cfg.tpl === 'photo' || cfg.tpl === 'photoclassic') && !vals.photo) vals.photo = jar.getAttribute('data-photo');
    jarReady(jar, jar.getAttribute('data-jar'), function () { draw(jar, cfg, vals, { logoSrc: jar.getAttribute('data-logo'), classicLogoSrc: jar.getAttribute('data-logo-classic'), scent: cfg.scent }); });
  }
  var sampleJars = Array.prototype.slice.call(document.querySelectorAll('[data-snjar]'));
  if (sampleJars.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); drawSample(e.target); } }); }, { rootMargin: '400px' });
      sampleJars.forEach(function (j2) { io.observe(j2); });
    } else sampleJars.forEach(drawSample);
  }

  /* ---------------- product pages: the product's own label, live on the jar ----------------
     Reads the order fields themselves (data-prop = the exact property name; cfg.props maps it to a label slot), the
     chosen scent and size, and an uploaded photo (kept on the device). Fields that share a slot are joined with " · ". */
  function renderFlat(box, cfg, vals, opts) {
    if (isBds(cfg) && !bdsReady()) { loadBDS(function () { renderFlat(box, cfg, vals, opts); }); return; }
    var el = build(cfg, vals, opts);
    box.innerHTML = ''; box.appendChild(el);
    if (el.classList.contains('dz-front')) {  // the Western + Chinese pair: show the back label under the front
      var bk = build(cfg, vals, Object.assign({}, opts, { side: 'back' }));
      var holder = document.createElement('div'); holder.style.cssText = 'margin-top:12px'; box.appendChild(holder);
      L.fontsReady().then(function () { return document.fonts.ready; }).then(function () {
        holder.appendChild(bk); var s2 = Math.min((box.clientWidth || bk.offsetWidth) / bk.offsetWidth, 2.6);
        bk.style.transformOrigin = '0 0'; bk.style.transform = 'scale(' + s2 + ')'; holder.style.height = (bk.offsetHeight * s2) + 'px';
        box.style.height = 'auto';
      });
    }
    void el.offsetWidth;
    if (isBds(cfg)) {  // provisional fit straight away, refined once fonts and art have loaded
      var s0 = Math.min((box.clientWidth || el.offsetWidth) / el.offsetWidth, 2.6);
      el.style.transformOrigin = '0 0'; el.style.transform = 'scale(' + s0 + ')'; box.style.height = (el.offsetHeight * s0) + 'px';
    }
    L.fontsReady().then(function () { return document.fonts.ready; }).then(function () { return imagesReady(el); }).then(function () { return artReady(el); }).then(function () {
      el.style.transform = 'none';
      fitAny(el, cfg);
      var s = Math.min((box.clientWidth || el.offsetWidth) / el.offsetWidth, 2.6);
      el.style.transformOrigin = '0 0'; el.style.transform = 'scale(' + s + ')';
      box.style.height = (el.offsetHeight * s) + 'px';
    });
  }
  Array.prototype.forEach.call(document.querySelectorAll('[data-snpdp]'), function (jar) {
    var cfg; try { cfg = JSON.parse(jar.getAttribute('data-snpdp')); } catch (e) { return; }
    var wrap = jar.closest('[data-snpdp-wrap]'), sec = jar.closest('.shopify-section') || document;
    var form = sec.querySelector('form.pform'); if (!form) return;
    var PD = {}; try { PD = JSON.parse(sec.querySelector('#snProductData').textContent); } catch (e) { PD = {}; }
    var mini = sec.querySelector('[data-snpdp-mini]'), flat = wrap.querySelector('[data-snpdp-flat]');
    var img = wrap.querySelector('img.snj-static'), view = 'jar', photoUrl = null, lastVariant = null;
    var story = cfg.tpl === 'story' ? sec.querySelector('[data-snpdp-story]') : null;
    var dim = { 1: 31, 2: 29, 3: 31, 4: 30, 5: 31, 6: 30, 7: 31, 8: 31, 9: 30, 10: 31, 11: 30, 12: 31 };

    function variant() {
      var id = +((form.querySelector('[data-variant-input]') || {}).value || 0);
      return (PD.variants || []).filter(function (v) { return v.id === id; })[0] || null;
    }
    function opts() {
      var v = variant(), o = { scent: '', netWeight: '285 g', logoSrc: jar.getAttribute('data-logo'), classicLogoSrc: jar.getAttribute('data-logo-classic') };
      if (v && PD.si > -1) { var raw = v.o[PD.si] || '', m = PD.scents && PD.scents[raw]; o.scent = m ? m.n : raw.replace(/^\([^)]*\)\s*/, ''); }
      if (v && PD.zi > -1 && /medium/i.test(v.o[PD.zi] || '')) o.netWeight = '225 g';
      return o;
    }
    function storyKey() {
      if (!story) return null;
      var m = +story.querySelector('[data-snpdp-month]').value, d = +story.querySelector('[data-snpdp-day]').value;
      return m && d ? pad(m) + '-' + pad(Math.min(d, dim[m])) : null;
    }
    function values() {
      var v = {}, optional = [], typed = false;
      Array.prototype.forEach.call(form.querySelectorAll('[data-prop]'), function (inp) {
        var slot = cfg.props && cfg.props[inp.getAttribute('data-prop')];
        if (!slot || inp.type === 'file' || inp.type === 'hidden' || inp.disabled) return;
        var val = (inp.value || '').trim();
        if (!val) { if (inp.getAttribute('data-req') !== '1') optional.push(slot); return; }
        typed = true;
        v[slot] = v[slot] ? v[slot] + ' · ' + val : val;
      });
      var rc = cfg.recipe;
      if (cfg.tpl === 'photo' || cfg.tpl === 'photoclassic' || (rc && rc.photo)) v.photo = photoUrl || jar.getAttribute(rc && rc.pet ? 'data-photo-pet' : 'data-photo') || jar.getAttribute('data-photo');
      if (cfg.tpl === 'streetmap' || cfg.map) { v.mapImg = mapImg; v.view = mapView; v.shape = cfg.shape; }
      if ((cfg.tpl === 'starmap' || cfg.sky) && skyGeo.hit && v.location === skyGeo.q) { v.lat = skyGeo.hit.lat; v.lon = skyGeo.hit.lon; v.tz = skyGeo.hit.tz; }
      if (cfg.tpl === 'story') {
        v.key = storyKey() || '07-14'; if (!v.name && !storyKey()) v.name = (cfg.sample || {}).name || '';
        var ys = story && story.querySelector('[data-snpdp-year]'); if (ys && ys.value) v.year = ys.value;
        var fin = story && story.__bds && story.__bds.final; if (fin) { v.west = fin.west; v.cnA = fin.cnA; v.cnE = fin.cnE; }
        var nfi = form.querySelector('[data-prop="Name Font"]'); v.nameFont = nfi && /classic/i.test(nfi.value) ? 'classic' : 'script';
      }
      else if (rc && typed) optional.forEach(function (k) { if (!(k in v)) v[k] = ''; });  // once they start, an optional field left empty stays off the label
      else Object.keys(cfg.sample || {}).forEach(function (k) { if (!v[k]) v[k] = cfg.sample[k]; });
      return v;
    }
    var ANIMALS = ['Rat', 'Ox', 'Tiger', 'Rabbit', 'Dragon', 'Snake', 'Horse', 'Goat', 'Monkey', 'Rooster', 'Dog', 'Pig'];
    var STEMS = ['Metal', 'Metal', 'Water', 'Water', 'Wood', 'Wood', 'Fire', 'Fire', 'Earth', 'Earth'];
    function cnOf(cy) { return { e: STEMS[cy % 10], a: ANIMALS[((cy - 4) % 12 + 12) % 12] }; }
    function bdsUI() {   // cusp-day / Lunar New Year pickers + the hidden order fields the Label Studio reads
      if (story.__bds) return story.__bds;
      var box = document.createElement('div'); box.className = 'bds-checks';
      box.innerHTML = '<div class="bds-pick" data-bds-cusp hidden><p class="small" style="margin:8px 0 4px"><b>Your sign changes on this day</b> — choose yours:</p><div class="bds-opts" data-bds-opts="west"></div><p class="small muted" data-bds-cusp-note style="margin:4px 0 0"></p></div>' +
        '<div class="bds-pick" data-bds-cny hidden><p class="small" style="margin:8px 0 4px"><b>Born right at Lunar New Year</b> — confirm their Chinese sign:</p><div class="bds-opts" data-bds-opts="cn"></div><p class="small muted" data-bds-cny-note style="margin:4px 0 0"></p></div>';
      story.insertBefore(box, story.querySelector('[data-snpdp-cap]'));
      ['_Date of Birth', '_Core Profile', '_Birthday Profile', '_Label Design', '_Sign Check', '_Chinese Check'].forEach(function (p) {
        if (story.querySelector('[data-prop="' + p + '"]')) return;
        var i = document.createElement('input'); i.type = 'hidden'; i.name = 'properties[' + p + ']'; i.setAttribute('data-prop', p); story.appendChild(i);
      });
      var nm = form.querySelector('[data-prop="Name on Label"]');   // the new label is "Personalised for <name>": the name is required
      if (nm) { nm.required = true; nm.setAttribute('data-req', '1'); var opt = nm.parentNode.querySelector('label .muted'); if (opt) opt.textContent = '*'; }
      story.__bds = { west: '', cn: '', final: null };
      box.addEventListener('change', function (e) { var r = e.target; if (r.name && r.name.indexOf('bdsw') === 0) story.__bds.west = r.value; if (r.name && r.name.indexOf('bdsc') === 0) story.__bds.cn = r.value; soon(); });
      return story.__bds;
    }
    function radios(holder, name, list, chosen) {
      var html = list.map(function (o) { return '<label class="bds-opt"><input type="radio" name="' + name + '" value="' + o.v + '"' + (o.v === chosen ? ' checked' : '') + '> ' + o.t + '</label>'; }).join('');
      if (holder.__h !== html) { holder.innerHTML = html; holder.__h = html; }
    }
    function bdsProps() {   // Birthdate Story: Sun-sign (cusp days asked), Lunar New Year (boundary days asked), profile IDs
      var st = bdsUI(), set = function (p, val) { var i = story.querySelector('[data-prop="' + p + '"]'); if (i) i.value = val; };
      var cap = story.querySelector('[data-snpdp-cap]'), key = storyKey(), ys = story.querySelector('[data-snpdp-year]'), yv = ys && ys.value;
      var cuspBox = story.querySelector('[data-bds-cusp]'), cnyBox = story.querySelector('[data-bds-cny]');
      var clear = function (msg) {
        ['Birthdate', 'Star Sign', 'Label', 'Birth Year', 'Chinese Zodiac', '_Date of Birth', '_Core Profile', '_Birthday Profile', '_Label Design', '_Sign Check', '_Chinese Check'].forEach(function (p) { set(p, ''); });
        cuspBox.hidden = cnyBox.hidden = true; st.final = null; cap.textContent = msg;
      };
      if (!key || !yv) { clear('Sample shown: choose their birthday and birth year to see their own label (front and back).'); return; }
      var B = window.BDS, iso = yv + '-' + key, p = B.parseDate(iso);
      if (!p.ok) { clear(p.error + '. Please check the date.'); return; }
      var sol = B.solarSign(p, 'Australia/Sydney'), west = sol && sol.sign;
      if (sol && sol.cusp) {
        cuspBox.hidden = false;
        if ([sol.signBefore, sol.signAfter].indexOf(st.west) < 0) st.west = sol.sign;
        radios(cuspBox.querySelector('[data-bds-opts]'), 'bdsw' + key + yv, [{ v: sol.signBefore, t: sol.signBefore + ' (born before ' + sol.ingressLocal.split(', ').pop() + ')' }, { v: sol.signAfter, t: sol.signAfter + ' (born after)' }], st.west);
        cuspBox.querySelector('[data-bds-cusp-note]').textContent = 'The Sun moved into ' + sol.signAfter + ' at ' + sol.ingressLocal + '. If you’re not sure of the birth time, we’ve picked the sign at midday.';
        west = st.west;
      } else { cuspBox.hidden = true; st.west = ''; }
      var auto = B.chinese(p, 'lny'), cn = auto.animal ? { e: auto.element, a: auto.animal } : null;
      if (auto.status === 'boundary') {
        cnyBox.hidden = false;
        var alt = cnOf(p.iso >= auto.boundary ? auto.chineseYear - 1 : auto.chineseYear + 1), a1 = auto.element + ' ' + auto.animal, a2 = alt.e + ' ' + alt.a;
        if ([a1, a2].indexOf(st.cn) < 0) st.cn = a1;
        radios(cnyBox.querySelector('[data-bds-opts]'), 'bdsc' + key + yv, [{ v: a1, t: a1 }, { v: a2, t: a2 }], st.cn);
        cnyBox.querySelector('[data-bds-cny-note]').textContent = 'Lunar New Year ' + p.y + ' fell on ' + auto.boundary.split('-').reverse().join('/') + ' (Hong Kong time). We’ve picked ' + a1 + '; change it if their family counts it differently.';
        var pc = st.cn.split(' '); cn = { e: pc[0], a: pc[1] };
      } else { cnyBox.hidden = true; st.cn = ''; }
      if (!cn) { clear('Please choose a birth year from 1901 onwards.'); return; }
      st.final = { west: west, cnA: cn.a, cnE: cn.e };
      var md = B.compose({ order_id: 'PDP', name: 'x', date_of_birth: iso, western_sign: west, chinese_animal: cn.a, chinese_element: cn.e, confirmed: true }, { mode: 'customer' });
      var bd = window.BDS_DATA.birthdays[key], mon = B.MONTHS[p.m - 1];
      set('Birthdate', p.d + ' ' + mon); set('Star Sign', west); set('Label', key + ' · ' + bd.title); set('Birth Year', String(p.y));
      set('Chinese Zodiac', cn.e + ' ' + cn.a); set('_Date of Birth', iso); set('_Core Profile', md.ok ? md.ids.core : ''); set('_Birthday Profile', bd.id);
      var nfv = (story.querySelector('[data-prop="Name Font"]') || form.querySelector('[data-prop="Name Font"]') || {}).value || 'Script';
      set('_Label Design', 'Birthdate Story 102x64 front + back · ' + nfv + ' name');
      set('_Sign Check', sol && sol.cusp ? 'Cusp day (Sun entered ' + sol.signAfter + ' ' + sol.ingressLocal + '): customer chose ' + west : 'Sun position on the birth date');
      set('_Chinese Check', auto.status === 'boundary' ? 'Lunar New Year boundary (' + auto.boundary + '): customer chose ' + cn.e + ' ' + cn.a : 'Lunar New Year (HKO tables)');
      cap.innerHTML = p.d + ' ' + mon + ' ' + p.y + ' · ' + west + ' + ' + cn.e + ' ' + cn.a + ' · <b>“' + String(bd.title).replace(/[<>&]/g, '') + '”</b>';
    }
    function storyProps() {  // the order fields the Birthday Story section always sent: Birthdate, Star Sign, Label
      if (!story || !D) return;
      if (isBds(cfg)) { if (bdsReady()) bdsProps(); else loadBDS(soon); return; }
      var key = storyKey(), set = function (p, val) { var i = story.querySelector('[data-prop="' + p + '"]'); if (i) i.value = val; };
      var cap = story.querySelector('[data-snpdp-cap]');
      if (!key) { set('Birthdate', ''); set('Star Sign', ''); set('Label', ''); cap.textContent = 'Sample shown: choose their birthday to see their own label.'; return; }
      var m = +key.slice(0, 2), d = +key.slice(3), day = D.days[key], mon = D.months[m - 1], s = signOf(key);
      set('Birthdate', d + ' ' + mon.name); set('Star Sign', s.name); set('Label', key + ' · ' + day.title);
      cap.innerHTML = d + ' ' + mon.name + ' · ' + s.name + ' · <b>“' + day.title.replace(/[<>&]/g, '') + '”</b>';
      var ys = story.querySelector('[data-snpdp-year]');
      if (ys) {  // Western + Chinese: the birth year sets the Chinese zodiac (Chinese New Year aware)
        var yv = +ys.value, f = yv && window.SNDual ? window.SNDual.facts(yv, m, d) : null;
        set('Birth Year', f ? String(yv) : ''); set('Chinese Zodiac', f ? f.element + ' ' + f.animal.name : '');
        if (f) cap.innerHTML = d + ' ' + mon.name + ' ' + yv + ' · ' + s.name + ' + ' + f.element + ' ' + f.animal.name + ' · <b>“' + day.title.replace(/[<>&]/g, '') + '”</b>';
        else cap.innerHTML += ' · <span>add the birth year for their Chinese zodiac</span>';
      }
    }
    function propInput(slot) {
      var prop = Object.keys(cfg.props || {}).filter(function (k) { return cfg.props[k] === slot; })[0];
      return prop ? Array.prototype.filter.call(form.querySelectorAll('[data-prop]'), function (i) { return i.getAttribute('data-prop') === prop && i.type !== 'hidden'; })[0] : null;
    }
    function note(inp, text) {
      if (!inp) return;
      var n = inp.parentNode.querySelector('[data-snpdp-note]');
      if (!n) { n = document.createElement('p'); n.className = 'small muted'; n.setAttribute('data-snpdp-note', ''); n.style.margin = '6px 0 0'; inp.parentNode.appendChild(n); }
      n.textContent = text; n.hidden = !text;
    }
    // star map: a town that isn't on the built-in list (e.g. Nelson Bay) is looked up with the same place search the street map
    // and the Label Studio use, so the preview draws the sky for its exact coordinates instead of a sample (Deng 2026-10-04)
    var skyGeo = { q: '', hit: null, none: false, ticket: 0 };
    function nearestTz(lat, lon) {
      var P = window.SN_PLACES || [], best = null, bd = 1e9;
      for (var i = 0; i < P.length; i++) { var dy = P[i][4] - lat, dx = (P[i][5] - lon) * Math.cos(lat * Math.PI / 180), dd = dx * dx + dy * dy; if (dd < bd) { bd = dd; best = P[i]; } }
      return best ? best[6] : '';
    }
    function skyFind(q, pin) {
      var M = window.SNMap;
      if (!M || !M.geocode) { note(pin, 'We couldn’t find that place. Try adding the state or country, e.g. “Newcastle NSW” or “Paris, France”.'); return; }
      if (skyGeo.pending === q) return;
      var my = ++skyGeo.ticket; skyGeo.pending = q;
      note(pin, 'Finding “' + q + '”…');
      clearTimeout(skyGeo.t);
      skyGeo.t = setTimeout(function () {
        M.geocode(q).then(function (res) {
          if (my !== skyGeo.ticket) return;
          var r = res && res[0];
          skyGeo = { q: q, hit: r ? { lat: r.lat, lon: r.lon, tz: nearestTz(r.lat, r.lon), label: r.label } : null, none: !r, ticket: my };
          render();
        }, function () { if (my === skyGeo.ticket) { skyGeo.pending = ''; note(pin, 'The place search isn’t answering right now. Try “Town STATE”, e.g. “Newcastle NSW”.'); } });
      }, 600);
    }
    function starNotes() {  // star map: say which sky is drawn, and ask for a clearer date or place when needed
      var S = window.SNSky; if (!S) return;
      var pin = propInput('location'), din = propInput('date'), pv = pin ? pin.value.trim() : '', dv = din ? din.value.trim() : '';
      if (!pv) note(pin, 'The preview shows a sample sky until you add the place.');
      else {
        var hitp = S.findPlace(pv);
        if (hitp && !hitp.approx) { var c = S.fmtCoord(hitp.lat, hitp.lon); note(pin, 'Sky for ' + hitp.label + ' · ' + c[0] + ', ' + c[1] + '.'); }
        else if (skyGeo.q === pv && skyGeo.hit) { var c2 = S.fmtCoord(skyGeo.hit.lat, skyGeo.hit.lon); note(pin, 'Sky for ' + skyGeo.hit.label + ' · ' + c2[0] + ', ' + c2[1] + '.'); }
        else if (skyGeo.q === pv && skyGeo.none) note(pin, 'We couldn’t find “' + pv + '”. Try adding the state or country, e.g. “Nelson Bay NSW” or “Paris, France”.');
        else skyFind(pv, pin);
      }
      var w = dv ? S.parseDate(dv) : null;
      note(din, !dv ? '' : w ? 'The sky at 9 pm on ' + S.fmtDate(w) + ', local time.' : 'Please use a date like 14/02/2020 or 14 February 2020.');
    }
    // street map: the customer frames the spot on a live map; the label uses exactly that view (hidden order field "_Map view")
    var mapBox = (cfg.tpl === 'streetmap' || cfg.map) ? sec.querySelector('[data-snpdp-map]') : null, mapEd = null, mapImg = null, mapView = null, mapTicket = 0;
    function mapSetup() {
      if (!mapBox || !window.SNMap || !window.maplibregl) return;
      var S = window.SNSky, pin = propInput('location');
      var exact = function (q) { var h = q && S && S.findPlace(q); return h && !h.approx ? h : null; };  // a town not on our list: don't jump to the capital
      var start = (pin && exact(pin.value.trim())) || exact((cfg.sample || {}).location) || { lat: -32.9283, lon: 151.7817 };
      mapEd = window.SNMap.editor(mapBox, { lat: start.lat, lon: start.lon, zoom: 14.5, shape: cfg.shape, tone: cfg.tone, onView: function (v) {
        mapView = v;
        var hid = form.querySelector('[data-prop="_Map view"]'); if (hid) hid.value = window.SNMap.fmtView(v);
        var my = ++mapTicket;
        mapEd.capture(700).then(function (url) {
          if (my !== mapTicket) { URL.revokeObjectURL(url); return; }
          if (mapImg) setTimeout(URL.revokeObjectURL.bind(URL, mapImg), 4000);
          mapImg = url; soon();
        });
      } });
      if (pin) {
        // as they type the address (street, venue, beach or town), the map moves there: our own town list answers at once,
        // OpenStreetMap's place search (SNMap.geocode, Photon) finds the rest; other matches are offered as buttons
        var gt = 0, gTicket = 0, sug = document.createElement('div');
        sug.className = 'pdp-map-sug'; sug.hidden = true; pin.parentNode.appendChild(sug);
        var go = function (r, said) { mapEd.setCenter(r.lat, r.lon, r.zoom || 14.5); note(pin, (said || 'Showing ') + r.label + '. Drag and zoom the map until it\u2019s exactly right.'); };
        var offer = function (res) {
          sug.__res = res;
          sug.innerHTML = res.length > 1 ? '<span class="small muted">Not that one?</span>' + res.slice(1, 5).map(function (r, i) {
            return '<button type="button" class="pdp-map-pick" data-i="' + (i + 1) + '">' + r.label.replace(/[<>&"]/g, '') + '</button>'; }).join('') : '';
          sug.hidden = res.length < 2;
        };
        var find = function (q) {
          var my = ++gTicket;
          if (!q) { note(pin, ''); offer([]); return; }
          var hit = exact(q);
          if (hit) go({ lat: hit.lat, lon: hit.lon, zoom: 14.5, label: hit.label });
          if (!window.SNMap.geocode) return;
          if (!hit) note(pin, 'Finding \u201c' + q + '\u201d on the map\u2026');
          window.SNMap.geocode(q).then(function (res) {
            if (my !== gTicket) return;
            if (res.length) { go(res[0]); offer(res); }
            else if (!hit) { note(pin, 'We couldn\u2019t find \u201c' + q + '\u201d. Try the street and suburb (e.g. \u201cMagnus St, Nelson Bay NSW\u201d), or drag the map to the spot.'); offer([]); }
          }).catch(function () { if (my === gTicket && !hit) note(pin, 'Place search isn\u2019t available right now: drag and zoom the map to the spot.'); });
        };
        sug.addEventListener('click', function (e) {
          var b = e.target.closest('.pdp-map-pick'), r = b && sug.__res && sug.__res[+b.getAttribute('data-i')];
          if (r) go(r);
        });
        pin.addEventListener('input', function () { clearTimeout(gt); gt = setTimeout(function () { find(pin.value.trim()); }, 650); });
        if (pin.value.trim()) find(pin.value.trim());   // e.g. carried over from the homepage studio
      }
    }
    var t = 0;
    // Birthdate Story: until the shopper touches the form (or arrives with their date), the jar shows the pre-drawn sample
    // photo and the label module isn't loaded at all - keeps first paint and LCP light on phones.
    var bdsAwake = !isBds(cfg);
    function blankSrc() {
      var bl = img.getAttribute('data-blank'), sm = img.getAttribute('data-blank-sm');
      if (!bl) return img.currentSrc || img.src;
      return sm && (jar.clientWidth || 400) * (window.devicePixelRatio || 1) <= 700 ? sm : bl;
    }
    function wakeBds() { if (bdsAwake) return; bdsAwake = true; render(); }
    if (!bdsAwake) {
      ['focusin', 'pointerdown', 'keydown'].forEach(function (ev) { form.addEventListener(ev, wakeBds, { passive: true }); });
      Array.prototype.forEach.call(sec.querySelectorAll('.pdp-jar-view, [data-snpdp-wrap]'), function (el) { ['pointerdown', 'keydown', 'click'].forEach(function (ev) { el.addEventListener(ev, wakeBds, { passive: true }); }); });
    }
    if (isBds(cfg) && story) {   // never let an order through before the label module has filled the order fields
      var retried = false;
      form.addEventListener('submit', function (e) {
        if (!storyKey() || retried) return;
        var ss = story.querySelector('[data-prop="Star Sign"]');
        if (bdsReady() && ss && ss.value) return;
        e.preventDefault(); e.stopImmediatePropagation();
        wakeBds();
        loadBDS(function () { render(); retried = true; setTimeout(function () { retried = false; var b = form.querySelector('[type="submit"][name="add"]'); if (form.requestSubmit) form.requestSubmit(b || undefined); }, 250); });
      }, true);
    }
    function render() {
      if (!bdsAwake) return;
      storyProps();
      if (cfg.tpl === 'starmap' || cfg.sky) starNotes();
      var vals = values(), o = opts();
      if (view === 'flat' || view === 'back') renderFlat(flat, cfg, vals, view === 'back' ? Object.assign({}, o, { side: 'back' }) : o);
      else jarReady(jar, blankSrc(), function () { draw(jar, cfg, vals, o, function () { wrap.classList.add('live'); }); });
      if (mini && mini.offsetParent !== null) jarReady(mini, blankSrc(), function () { draw(mini, cfg, vals, o); });
    }
    function soon() { clearTimeout(t); t = setTimeout(render, 140); }
    form.addEventListener('input', soon);
    form.addEventListener('change', function (e) {
      if (e.target.type === 'file' && e.target.files && e.target.files[0] && cfg.props && cfg.props[e.target.getAttribute('data-prop')] === 'photo') {
        if (photoUrl) URL.revokeObjectURL(photoUrl);
        photoUrl = URL.createObjectURL(e.target.files[0]);
      }
      if (story && e.target.matches('[data-snpdp-month]')) {
        var m = +e.target.value, dayEl = story.querySelector('[data-snpdp-day]');
        Array.prototype.forEach.call(dayEl.options, function (op) { op.disabled = !!m && +op.value > dim[m]; });
        if (m && +dayEl.value > dim[m]) dayEl.value = String(dim[m]);
      }
      soon();
    });
    form.addEventListener('click', function () {  // scent / size buttons change the variant without an input event
      setTimeout(function () { var v = variant(), id = v && v.id; if (id !== lastVariant) { lastVariant = id; soon(); } }, 0);
    });
    if (isBds(cfg)) {   // Birthdate Story: a third view, the back label (flat)
      var grp = sec.querySelector('.pdp-jar-view'), fb = grp && grp.querySelector('[data-snpdp-view="flat"]');
      if (grp && !grp.querySelector('[data-snpdp-view="back"]')) {
        if (fb) fb.textContent = 'Front label';
        var bb = document.createElement('button'); bb.type = 'button'; bb.setAttribute('data-snpdp-view', 'back'); bb.setAttribute('aria-pressed', 'false'); bb.textContent = 'Back label'; grp.appendChild(bb);
      }
    }
    if (isBds(cfg) && story) {   // Name style: Script / Classic, sent as the visible order property "Name Font"
      var nmIn = form.querySelector('[data-prop="Name on Label"]'), nmField = nmIn && (nmIn.closest('.field') || nmIn.parentNode);
      if (nmField && !form.querySelector('[data-bds-font]')) {
        var fw = document.createElement('div'); fw.innerHTML = fontPickHtml('nf-' + (form.id || 'pdp'), nmIn.value, 'script');
        nmField.parentNode.insertBefore(fw.firstChild, nmField.nextSibling);
        var nfh = document.createElement('input'); nfh.type = 'hidden'; nfh.name = 'properties[Name Font]'; nfh.setAttribute('data-prop', 'Name Font'); nfh.value = 'Script';
        nmField.parentNode.insertBefore(nfh, nmField.nextSibling);
        form.addEventListener('change', function (e) { if (e.target.hasAttribute('data-bds-font')) nfh.value = e.target.value === 'classic' ? 'Classic' : 'Script'; }, true);
        nmIn.addEventListener('input', function () { fontSamples(form, nmIn.value); });
      }
    }
    Array.prototype.forEach.call(sec.querySelectorAll('[data-snpdp-view]'), function (b) {
      b.addEventListener('click', function () {
        view = b.getAttribute('data-snpdp-view');
        Array.prototype.forEach.call(sec.querySelectorAll('[data-snpdp-view]'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        flat.hidden = view === 'jar'; jar.hidden = view !== 'jar';
        render();
      });
    });
    // prefill from the homepage (studio: ?pf_<slot>=, Birthday Story hero: ?date=MM-DD&name=)
    var q = new URLSearchParams(location.search), used = false;
    Object.keys(cfg.props || {}).forEach(function (prop) {
      var slot = cfg.props[prop], val = q.get('pf_' + slot);
      if (!val) return;
      var inp = Array.prototype.filter.call(form.querySelectorAll('[data-prop]'), function (i) { return i.getAttribute('data-prop') === prop && i.type !== 'file' && i.type !== 'hidden'; })[0];
      if (inp && !inp.value) { inp.value = val.slice(0, inp.maxLength > 0 ? inp.maxLength : 200); used = true; }
    });
    if (story) {
      var dq = /^(\d\d)-(\d\d)$/.exec(q.get('date') || ''), nq = q.get('name');
      if (dq) { story.querySelector('[data-snpdp-month]').value = String(+dq[1]); story.querySelector('[data-snpdp-day]').value = String(+dq[2]); used = true; }
      var yq = /^\d{4}$/.exec(q.get('year') || ''), ysel = story.querySelector('[data-snpdp-year]');
      if (yq && ysel && ysel.querySelector('option[value="' + yq[0] + '"]')) { ysel.value = yq[0]; used = true; }
      var ni = form.querySelector('[data-prop="Name on Label"]'); if (nq && ni && !ni.value) { ni.value = nq.slice(0, 20); used = true; fontSamples(form, ni.value); }
      if (/^classic$/i.test(q.get('font') || '')) { var fc = form.querySelector('[data-bds-font][value="classic"]'), fh = form.querySelector('[data-prop="Name Font"]'); if (fc) fc.checked = true; if (fh) fh.value = 'Classic'; used = true; }
    }
    if (used || storyKey()) bdsAwake = true;   // came with their date/name from the homepage: draw theirs straight away
    if (used) Array.prototype.forEach.call(form.querySelectorAll('[data-prop]'), function (i) { if (i.value && i.type !== 'hidden') i.dispatchEvent(new Event('input', { bubbles: true })); });
    lastVariant = (variant() || {}).id;
    mapSetup();
    if (window.ResizeObserver) { var w0 = 0; new ResizeObserver(function () { var w = jar.clientWidth; if (Math.abs(w - w0) > 2) { w0 = w; render(); } }).observe(wrap); }
    render();
  });

  window.SNPersonalise = { build: build, draw: draw, jarReady: jarReady, ready: true };
})();
